module.exports = __webpack_public_path__ + "static/media/apng_poporin.3d10e95a.png";